import './staffMember.scss';
import * as React from 'react';
import { ImageUtils } from '../../utils/image';
import { ImageIcon } from '../imageIcon';
import { Card } from '../layout/card';
import { LazyCosmosImage } from '../media/cosmosImage';
export const StaffMember = ({ staffMember }) => {
    const mainImage = React.useMemo(() => {
        if (staffMember.photo_url[0]) {
            return { ticket: staffMember.photo_url[0].ticket };
        }
        if (staffMember.alt_photo_url[0]) {
            return { ticket: staffMember.alt_photo_url[0].ticket };
        }
        return { src: '/images/missing-crew-member.jpg' };
    }, []);
    return (<div className="staff-member">
      <div className="staff-member-image">
        <LazyCosmosImage {...mainImage} alt={`${staffMember.name} illustration`} size={ImageUtils.imageSizes.squareTiny}/>

        {staffMember.photo_url[0] && staffMember.alt_photo_url[0] && (<LazyCosmosImage className="staff-member-image-alt" wrapperClassname="staff-member-image-alt-wrapper" ticket={staffMember.alt_photo_url[0].ticket} alt={`${staffMember.name} illustration`} size={ImageUtils.imageSizes.squareTiny}/>)}
      </div>

      <Card className="staff-member-info">
        <h3>{staffMember.name}</h3>
        <p>{staffMember.position}</p>
        <StaffMemberSocials staffMember={staffMember}/>
      </Card>
    </div>);
};
const iconDictionary = {
    linked_in: 'linkedin',
};
export const StaffMemberSocials = ({ staffMember }) => {
    const socialKeys = Object.keys(staffMember.socials || {});
    return (<div className="staff-member-socials-row">
      {socialKeys?.map((socialKey) => staffMember.socials[socialKey] && (<StaffMemberSocialLink iconName={iconDictionary[socialKey] || socialKey} href={staffMember.socials[socialKey]} key={socialKey}/>))}
    </div>);
};
export const StaffMemberSocialLink = ({ href, iconName }) => (<a href={href} target="_blank" rel="noopener noreferrer">
    <ImageIcon iconName={iconName}/>
  </a>);
